import { FC } from "react";
import { Routes, Route, useLocation } from "react-router";
import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Breadcrumb } from "capitalrx-shell";
import { ModuleErrorBoundary } from "capitalrx-shell";
import { URL } from "../../constants/urls";
import { LegacyContentLayout } from "../layouts";
import { LegacyContentRoutes } from "./LegacyContentRoutes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    },
  },
});

/**
 * The legacy routes component.
 * @deprecated This component will be removed when everything is a module.
 */
export const LegacyRoutes: FC = () => {
  let path = useLocation().pathname;
  if (path.endsWith("/")) path = path.substr(0, path.length - 1);

  return (
    <QueryClientProvider client={queryClient}>
      <Breadcrumb title="Network" path={URL.HOME} />
      <Routes>
        <Route
          path="/invoice/report/:externalInvoiceID"
          element={
            <LegacyContentLayout fullscreen>
              <ModuleErrorBoundary></ModuleErrorBoundary>
            </LegacyContentLayout>
          }
        />
        <Route
          path="/*"
          element={
            <LegacyContentLayout>
              <LegacyContentRoutes />
            </LegacyContentLayout>
          }
        />
      </Routes>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
